// extracted by css-extract-rspack-plugin
export default {"TabList":"GFYOC"};